export default "__VITE_ASSET__D$vDOJg6__"